import { useInfiniteQuery } from '@tanstack/react-query';

import { getCurrentISOString } from 'utils/date.utils';

import { EVENTS_PER_PAGE_HOME } from 'constants/events.constant';
import { useLocale } from 'hooks/useLocale';

import { infiniteEventsQuery } from './queries';

interface Props {
  eventsPerPage: number;
}

export const useInfiniteEvents = ({ eventsPerPage }: Props) => {
  const { locale } = useLocale();

  const { data, fetchNextPage, hasNextPage, isFetching } = useInfiniteQuery(
    infiniteEventsQuery(
      {
        locale,
        filter: {
          endDatetime: { gte: getCurrentISOString() },
          unlistedEvent: { eq: false },
        },
        first: EVENTS_PER_PAGE_HOME,
        orderBy: 'startDatetime_ASC',
        skip: 0,
      },
      eventsPerPage,
    ),
  );

  const events = data?.pages.flatMap((page) => page.events);

  return {
    events,
    fetchNextPage,
    hasNextPage,
    isFetching,
  };
};
